import Marquee from "react-fast-marquee";
import { Droplets } from "lucide-react";

const ITEMS = [
  "Basement Waterproofing",
  "Foundation Repair",
  "Concrete Driveways",
  "Patios & Outdoor Living",
  "Drainage Solutions",
  "Exterior Waterproofing",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="mt-24 border-y border-white/10 py-8 overflow-hidden">
      <Marquee speed={32} gradient={false} pauseOnHover>
        {ITEMS.map((t) => (
          <span key={t} className="flex items-center">
            <span className="font-display text-outline uppercase font-semibold text-4xl md:text-6xl tracking-tight mx-6">
              {t}
            </span>
            <Droplets size={26} className="text-cyan-400/70 mx-2" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
